module.exports = __webpack_public_path__ + "img/logo_Axa.3e6399ef.svg";